window.$ = require('jquery');

$(document).ready(function() {
    var stylesheetUrl = "https://use.typekit.net/kfz6gko.css";

    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', stylesheetUrl));
});
